var _rect, _rect2, _g, _path, _circle, _circle2, _circle3, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWaitingToBeEnabled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 106,
    viewBox: "0 0 141 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.2834,
    y: 95.6252,
    width: 71.8579,
    height: 109.987,
    rx: 4.75627,
    transform: "rotate(-90 12.2834 95.6252)",
    stroke: "#d8ddeb",
    strokeWidth: 0.792479,
    strokeDasharray: "3.96 3.96"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5806_10881",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 32,
    width: 111,
    height: 74
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 110.779,
    y: 32.8809,
    width: 72.7558,
    height: 110.779,
    rx: 5.15251,
    transform: "rotate(90 110.779 32.8809)",
    fill: "#b3becd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5806_10881)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 105.789,
    width: 72.6504,
    height: 110.779,
    rx: 5.15251,
    transform: "rotate(-90 0 105.789)",
    fill: "#c7f0ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.871 32.605h3.62276v73.3609H106.871z",
    fill: "#82ddff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8273 44.3789C11.693 44.3789 9.96289 46.109 9.96289 48.2433V90.3275C9.96289 92.4617 11.693 94.1919 13.8273 94.1919H42.3261C44.4604 94.1919 46.1905 92.4617 46.1905 90.3275V48.2433C46.1905 46.1091 44.4604 44.3789 42.3261 44.3789H13.8273zM60.6249 48C58.6554 48 57.0588 49.5966 57.0588 51.5662 57.0588 53.5357 58.6554 55.1323 60.6249 55.1323H95.494C97.4635 55.1323 99.0602 53.5357 99.0602 51.5662 99.0602 49.5966 97.4635 48 95.494 48H60.6249zM58.5588 60.8564C57.7304 60.8564 57.0588 61.528 57.0588 62.3564 57.0588 63.1849 57.7304 63.8564 58.5588 63.8564H73.5588C74.3872 63.8564 75.0588 63.1849 75.0588 62.3564 75.0588 61.528 74.3872 60.8564 73.5588 60.8564H58.5588zM57.0588 68.6963C57.0588 67.8679 57.7304 67.1963 58.5588 67.1963H81.5588C82.3872 67.1963 83.0588 67.8679 83.0588 68.6963 83.0588 69.5247 82.3872 70.1963 81.5588 70.1963H58.5588C57.7304 70.1963 57.0588 69.5247 57.0588 68.6963z",
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 79,
    cy: 89,
    r: 5,
    fill: "#82ddff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 93.5215,
    cy: 89,
    r: 5,
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.5294,
    cy: 64.2452,
    r: 5.37507,
    fill: "#82ddff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.039 78.332C38.039 81.7733 33.7814 81.154 28.5293 81.154 23.2772 81.154 19.0195 81.7733 19.0195 78.332 19.0195 74.8908 23.2772 72.1011 28.5293 72.1011 33.7814 72.1011 38.039 74.8908 38.039 78.332z",
    fill: "#82ddff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123 6C116.376 6 111 11.376 111 18 111 24.624 116.376 30 123 30 129.624 30 135 24.624 135 18 135 11.376 129.624 6 123 6zM119.748 23.148 115.44 18.84C114.972 18.372 114.972 17.616 115.44 17.148 115.908 16.68 116.664 16.68 117.132 17.148L120.6 20.604 128.856 12.348C129.324 11.88 130.08 11.88 130.548 12.348 131.016 12.816 131.016 13.572 130.548 14.04L121.44 23.148C120.984 23.616 120.216 23.616 119.748 23.148z",
    fill: "#00d494"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaitingToBeEnabled);
export default __webpack_public_path__ + "static/media/waiting_to_be_enabled.1e222ddc.svg";
export { ForwardRef as ReactComponent };